module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/152.defb5f03.png";